<template>
  <div :class="{ 'fixed-position': showPartsFilters }" ref="products_list_transition" class="scroll-to-min">
    <parts-filters v-if="vendor === 'wellfar'" :category="category" :filter="filter" @set-detail="setDetail" />

    <div class="properties properties-desktop" v-if="!$noCartMode()">
      <div class="checkbox" v-if="showExpressCheckbox">
        <label :class="{ checked: express }" @click="notifyExpressCart">
          <input v-model="express" @change="changeExpress" :disabled="disabledExpressCheckbox" class="styled-checkbox" type="checkbox" />
          {{ $t('express') }}
        </label>
      </div>
      <div class="checkbox checkbox-preorder" v-if="showHidePriceOnRequestCheckbox">
        <label :class="{ checked: hidePriceOnRequest }">
          <input v-model="hidePriceOnRequest" @change="changeHidePriceOnRequest" class="styled-checkbox" type="checkbox" />
          {{ $t('hide_price_on_request') }}
        </label>
      </div>
      <div class="checkbox checkbox-preorder" v-if="showHidePreorderCheckbox">
        <label :class="{ checked: hidePreorder }">
          <input v-model="hidePreorder" @change="changeHidePreorder" class="styled-checkbox" type="checkbox" />
          {{ $t('hide_preorder') }}
        </label>
      </div>

      <Filters v-if="vendor !== 'wellfar'" @set-filter="setFilter" :initial-query="true" :category="category" />
    </div>

    <div class="properties properties-mobile" v-if="!$device.isDesktop">
      <div class="filters-header">
        <div
          class="filters-main"
          v-if="vendor === 'wellfar'"
          @click="
            openPartsFilters();
            showDropdown = false;
          "
          :class="{ 'open-properties': showPartsFilters }"
        >
          <span>{{ $t('makers') }}</span>
          <i class="svg-icon arrow-mobile" :class="{ 'rotate-270': showPartsFilters }"></i>
        </div>

        <div
          v-if="showExpressCheckbox || showHidePreorderCheckbox || showHidePriceOnRequestCheckbox"
          class="filters-main"
          @click="
            showDropdown = !showDropdown;
            showPartsFilters = false;
          "
          :class="{ 'open-properties': showDropdown }"
        >
          <span>{{ $t('filters') }}</span>
          <i class="svg-icon arrow-mobile" :class="{ 'rotate-270': showDropdown }"></i>
        </div>
      </div>

      <transition name="fade">
        <div v-show="showDropdown" class="checkboxes-filters">
          <div class="checkboxes" v-if="showExpressCheckbox || showHidePreorderCheckbox">
            <div class="checkbox" v-if="showExpressCheckbox">
              <label :class="{ checked: express }" @click="notifyExpressCart">
                <input
                  v-model="express"
                  @change="changeExpress()"
                  :disabled="disabledExpressCheckbox"
                  class="styled-checkbox"
                  type="checkbox"
                />
                {{ $t('express') }}
              </label>
            </div>
            <div class="checkbox checkbox-preorder" v-if="showHidePriceOnRequestCheckbox">
              <label :class="{ checked: hidePriceOnRequest }">
                <input v-model="hidePriceOnRequest" @change="changeHidePriceOnRequest" class="styled-checkbox" type="checkbox" />
                {{ $t('hide_price_on_request') }}
              </label>
            </div>
            <div class="checkbox checkbox-preorder" v-if="showHidePreorderCheckbox">
              <label :class="{ checked: hidePreorder }">
                <input v-model="hidePreorder" @change="changeHidePreorder()" class="styled-checkbox" type="checkbox" />
                {{ $t('hide_preorder') }}
              </label>
            </div>
          </div>
          <transition name="fade">
            <Filters
              v-if="vendor !== 'wellfar'"
              @set-filter="setFilter"
              @set-selected-filters="setSelectedFilters"
              :initial-query="true"
              :category="category"
            />
          </transition>
        </div>
      </transition>

      <transition name="fade">
        <div v-show="showPartsFilters" class="parts-filters-filters" :style="{ height: `calc(100dvh - ${categoryHeight}px - 85px)` }">
          <transition name="fade">
            <parts-filters
              ref="partsFilters"
              :category="category"
              :filter="filter"
              @set-detail="setDetail"
              @close-parts="closeParts"
              @set-selected-parts="setSelectedParts"
            />
          </transition>
        </div>
      </transition>

      <div class="selected-filters">
        <div v-if="vendor === 'wellfar'">
          <div v-show="mark">
            <span v-if="detail">{{ mark }} {{ detail }}</span>
            <span v-else>{{ mark }}</span>
            <i class="svg-icon cross" @click="clearPartsFilterClose"></i>
          </div>

          <div v-if="showExpressCheckbox && express">
            <span>{{ $t('express') }}</span>
            <i
              class="svg-icon cross"
              @click="
                express = false;
                changeExpress();
              "
            />
          </div>

          <div v-if="showHidePriceOnRequestCheckbox && hidePriceOnRequest">
            <span>{{ $t('hide_price_on_request') }}</span>
            <i
              class="svg-icon cross"
              @click="
                hidePriceOnRequest = false;
                changeHidePriceOnRequest();
              "
            />
          </div>

          <div v-if="showHidePreorderCheckbox && hidePreorder">
            <span>{{ $t('hide_preorder') }}</span>
            <i
              class="svg-icon cross"
              @click="
                hidePreorder = false;
                changeHidePreorder();
              "
            />
          </div>
        </div>

        <div class="checkboxes-filters" v-if="express || (hidePreorder && vendor !== 'wellfar')">
          <div class="checkbox" v-if="showExpressCheckbox && express">
            <label :class="{ checked: express }" @click="notifyExpressCart">
              <input
                v-model="express"
                @change="changeExpress()"
                :disabled="disabledExpressCheckbox"
                class="styled-checkbox"
                type="checkbox"
              />
              {{ $t('express') }}
            </label>
          </div>
          <div class="checkbox" v-if="showHidePriceOnRequestCheckbox && hidePriceOnRequest">
            <label :class="{ checked: hidePriceOnRequest }">
              <input v-model="hidePriceOnRequest" @change="changeHidePriceOnRequest()" class="styled-checkbox" type="checkbox" />
              {{ $t('hide_price_on_request') }}
            </label>
          </div>
          <div class="checkbox checkbox-preorder" v-if="showHidePreorderCheckbox && hidePreorder">
            <label :class="{ checked: hidePreorder }">
              <input v-model="hidePreorder" @change="changeHidePreorder()" class="styled-checkbox" type="checkbox" />
              {{ $t('hide_preorder') }}
            </label>
          </div>
        </div>

        <template v-if="vendor !== 'wellfar'" v-for="filter in filters">
          <div class="sel-filter" v-if="selectedFilters[filter].length">
            <template v-for="(item, index) in selectedFilters[filter]">
              <a href="#" @click.prevent="clearValue(filter, item, index)">
                <span>{{ item }}</span>
                <i class="svg-icon cross" />
              </a>
            </template>
          </div>
        </template>
      </div>
    </div>

    <Content v-if="categoryTopText && categoryTopText.length" :page="{ content: categoryTopText }" :h1hide="h1hide" />

    <div
      ref="products_list"
      class="products-list"
      :class="{'products-list-limited': $hideStockAvailabilityColumns()}"
    >
      <products-list-header 
        v-if="products.results && products.results.length"
      />

      <products-list-item
        v-for="product in products.results"
        :key="product.id"
        :product="product"
        :stocks="stocks"
        :express="express"
        :hide-preorder="hidePreorder"
        :hide-price-on-request="hidePriceOnRequest"
        @fetch-products="fetchProducts"
        @remove-favourite="$emit('remove-favourite')"
        @show-price-request-modal="showPriceRequestModal = true"
      />

      <h1 v-if="products.results && !products.results.length">{{ $t('not_found') }}</h1>
    </div>

    <div class="pagination">
      <paginator
        v-if="products.count"
        :page="page"
        :items-per-page="products.page_size"
        :show-all-page="false"
        :total-items="products.count"
        @change-page="changePage"
      />
    </div>

    <Content v-if="categoryBottomText && categoryBottomText.length" :page="{ content: categoryBottomText }" />

    <modal :visible="showPriceRequestModal" @close="showPriceRequestModal = false" v-if="!$noCartMode()">
      <template v-slot:header>
        <div>{{ $t('price_request_saved_1') }}<br />{{ $t('price_request_saved_2') }}</div>
      </template>
      <template v-slot:body>
        <div></div>
      </template>
      <template v-slot:footer>
        <button class="modal-default-button" @click.prevent="$router.push({ path: localePath('/price-request/') })">
          {{ $t('go_to_price_request_page') }}
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import { Product } from '@/models/product';
import Cookies from 'js-cookie';

import { Stock } from '@/models/stock';

import Content from '@/components/content';
import Filters from '@/components/catalog/filters';
import Modal from '@/components/modal';
// import Paginator from '@/components/paginator';
import Paginator from '@/components/paginator_new';
import PartsFilters from '@/components/catalog/parts-filters';
import ProductsListHeader from '@/components/catalog/products-list-header';
import ProductsListItem from '@/components/catalog/products-list-item';
import SiteTextBlock from '@/components/blocks/site-text-block';

export default {
  components: {
    Content,
    Filters,
    Modal,
    Paginator,
    PartsFilters,
    ProductsListHeader,
    ProductsListItem,
    SiteTextBlock,
  },
  props: ['category', 'favourites', 'searchHistory', 'seo', 'filter', 'h1hide'],
  data() {
    return {
      products: {},
      id: new Date().getTime(),
      express: false,
      hidePreorder: false,
      hidePriceOnRequest: false,
      stocks: [],
      selectedFilters: {},
      showDropdown: false,
      showPartsFilters: false,
      filters: [],
      showVatWarning: true,
      showPriceModal: false,
      showPriceRequestModal: false,
      mark: null,
      detail: null,
      categoryHeight: 0,
      priceListExists: false,
    };
  },
  watch: {
    showPartsFilters: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          document.body.classList.add('no-scroll');
        } else {
          document.body.classList.remove('no-scroll');
        }
      },
    },
  },
  computed: {
    vendor() {
      return process.env.VENDOR;
    },
    hideStockAvailabilityColumns() {
      return this.vendor === 'wellfar' && !this.$auth.loggedIn;
    },
    disabledExpressCheckbox() {
      return this.$store.getters.cartExists.count > 0;
    },
    showExpressCheckbox() {
      // return false;
      return (
        this.$auth.loggedIn &&
        this.$auth.hasScope('is_extra') &&
        (!this.$store.getters.cartExists.count || this.$store.getters.cartExists.express)
      );
    },
    showHidePreorderCheckbox() {
      return !this.express && this.priceListExists;
    },
    showHidePriceOnRequestCheckbox() {
      return !this.express && this.priceListExists;
    },
    page() {
      return parseInt(this.$route.query.page || 1);
    },
    queryParams() {
      const params = { ...this.$route.query };
      if (this.category) {
        params.category = this.category.id;
      }
      if (this.favourites) {
        params.favourites = 1;
      }
      if (this.searchHistory) {
        params.search_history_id = this.searchHistory.id;
      }
      if (this.filter) {
        params.filter = this.filter;
      }
      return params;
    },
    selectedFiltersTotal() {
      return this.filters.map((x) => !this.selectedFilters[x].length);
    },
    categoryTopText() {
      return this.seo?.category_seo_text_obzor?.length ? this.seo.category_seo_text_obzor[0].top_text : null;
    },
    categoryBottomText() {
      return this.seo?.category_seo_text_obzor?.length ? this.seo.category_seo_text_obzor[0].bottom_text : null;
    },
    transitionKey() {
      return [
        this.page || 0,
        this.express ? 'express' : '',
        this.hidePreorder ? 'hide_preorder' : '',
        this.hidePriceOnRequest ? 'hide_price_on_request' : '',
        this.mark ? 'mark' : '',
        this.detail ? 'detail' : '',
      ].join('-');
    },
  },
  async fetch() {
    [this.stocks, this.priceListExists] = await Promise.all([
      Stock.config({ count_loading: true }).get(),
      this.$axios.$get(`/catalog/product/check-price-list-exists/`),
    ]);
  },
  mounted() {
    this.categoryHeight = this.$parent.$refs['h1Category']?.clientHeight;
    this.hidePreorder = !!parseInt(this.$route.query.hide_preorder || '');
    this.hidePriceOnRequest = !!parseInt(this.$route.query.hide_price_request || '');
    this.$store.dispatch('setCartExists', () => {
      if (this.$store.getters.cartExists.count) {
        this.express = this.$store.getters.cartExists.express;
      } else {
        this.express = !!parseInt(this.$route.query.express || '');
      }
      const params = {
        express: this.express ? 1 : 0,
        hide_preorder: this.hidePreorder ? 1 : 0,
        hide_price_request: this.hidePriceOnRequest ? 1 : 0,
      };
      this.changeQuery(params, false, true);
    });
    if (!this.$auth.loggedIn) {
      if (!this.$device.isCrawler) this.showPriceModal = true;
    } else {
      if (Cookies.get('vat-warning-shown') !== '1' && this.showVatWarning) {
        this.$notify({
          id: this.id,
          duration: -1,
          ignoreDuplicates: true,
          text: `${this.$t('no_vat_price_warning_1')} <button onclick="document.cookie=\'vat-warning-shown=1; max-age=36000000;\'" style="margin-left: 20px">${this.$t('no_vat_price_warning_2')}</a>`,
        });
        setInterval(() => {
          this.showVatWarning = Cookies.get('vat-warning-shown') !== '1';
          if (!this.showVatWarning) {
            this.$notify.close(this.id);
          }
        }, 1000);
      }
    }
  },
  methods: {
    notifyExpressCart() {
      if (this.disabledExpressCheckbox) {
        this.$notify({
          duration: 5000,
          text: this.$t('express_cart_warning'),
        });
      }
    },
    changeExpress() {
      this.changeQuery({ page: 1, express: this.express ? 1 : 0 }, false);
    },
    changeHidePreorder() {
      this.changeQuery({ page: 1, hide_preorder: this.hidePreorder ? 1 : 0 }, false);
    },
    changeHidePriceOnRequest() {
      this.changeQuery({ page: 1, hide_price_request: this.hidePriceOnRequest ? 1 : 0 }, false);
    },
    fetchProducts(scroll = false, countLoading = false) {
      if (scroll) {
        this.$refs['products_list'].style.opacity = '0';
        window.scrollTo(0, 0);
      }
      Product.config({ count_loading: countLoading })
        .params(this.queryParams)
        .first()
        .then((response) => {
          this.products = response;
          this.$refs['products_list'].style.opacity = '1';
          // if (scroll) {
          // window.scrollTo(0, 0)
          // document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
          // this.$refs.products_list_transition.scrollIntoView({behavior: 'smooth'});
          // }
        })
        .catch((e) => {
          if (this.page > 1) {
            this.changePage(this.page - 1);
          }
        });
    },
    changeQuery(params, scroll, countLoading = false) {
      countLoading = false;
      scroll = true;
      let query = { ...this.$route.query, ...params };
      if (query.page === 1) {
        delete query.page;
      }
      // if (query.page) {
      //   scroll = true
      // }
      if (query.express === 0) {
        delete query.express;
      }
      if (query.hide_preorder === 0) {
        delete query.hide_preorder;
      }
      if (query.hide_price_request === 0) {
        delete query.hide_price_request;
      }
      if (!query.mark) {
        delete query.mark;
      }
      if (!query.detail) {
        delete query.detail;
      }
      this.$router
        .replace({
          path: this.$route.path,
          query: query,
        })
        .catch(() => {})
        .finally(() => this.fetchProducts(scroll, countLoading));
    },
    changePage(page) {
      // window.scrollTo(0, 0)
      this.changeQuery({ page: page }, true);
    },
    setFilter(propId, value) {
      const params = { page: 1 };
      params[`p${propId}`] = value;
      this.changeQuery(params, false);
    },
    setDetail(mark = null, detail = null) {
      this.changeQuery({ page: 1, mark: mark, detail: detail }, false);
    },
    clearValue(filter, value, index) {
      this.selectedFilters[filter].splice(index, 1);
      this.setFilter(filter, this.selectedFilters[filter]);
    },
    setSelectedFilters(propId, value) {
      this.selectedFilters[propId] = value;
      this.filters.push(propId);
      this.filters = [...new Set(this.filters)];
    },
    closeParts() {
      this.showPartsFilters = false;
    },
    setSelectedParts(mark = null, detail = null) {
      this.mark = mark;
      this.detail = detail;
    },
    clearPartsFilterClose() {
      this.mark = null;
      this.detail = null;
      this.$refs.partsFilters.clear();
    },
    openPartsFilters() {
      window.scrollTo(0, 0);
      this.showPartsFilters = !this.showPartsFilters;
    },
  },
};
</script>

<i18n lang="yaml">
ru:
  hide_preorder: 'Скрыть товары «под заказ»'
  hide_price_on_request: 'Скрыть «цена по запросу»'
  not_found: 'Товаров по запросу не найдено'
  filters: 'Фильтры'
  guest_mode_warning_1:
    'В гостевом режиме показаны рекомендованные розничные цены. Для получения доступа к оптовым ценам и наличию перейдите на'
  guest_mode_warning_2: 'страницу регистрации'
  guest_mode_warning_3: 'Понятно'
  no_vat_price_warning_1: 'Цены указаны без учёта НДС.'
  no_vat_price_warning_2: 'Понятно'
  express_cart_warning: 'Т.к. создана экспресс-корзина, можно продолжить оформление только экспресс-заказа.'
  price_request_saved_1: 'Ваш запрос сохранен в папке'
  price_request_saved_2: '«Мои запросы»'
  go_to_price_request_page: 'Перейти в «Мои запросы»'
en:
  hide_preorder: 'Hide preorder products'
  hide_price_on_request: 'Hide «price on request»'
  not_found: 'Requested products not found'
  filters: 'Filters'
  guest_mode_warning_1: 'Recommended prices are specified in guest mode. Get access to trade prices by visiting'
  guest_mode_warning_2: 'registration page'
  guest_mode_warning_3: 'OK'
  no_vat_price_warning_1: 'Prices are specified without VAT.'
  no_vat_price_warning_2: 'OK'
  express_cart_warning: 'Only express order is available because express cart exists.'
  price_request_saved_1: 'Your request has been saved on'
  price_request_saved_2: '"My Requests" page'
  go_to_price_request_page: 'Go to My requests'
</i18n>
